/**
 * pc端公共js
 * 引入头部，有头部的可不引
 * @chenwei
 */
import React, { Component } from 'react';
import './index.less';

const flexible = require('asset/js/flexible.debug.js');

export default class PcPublic extends Component {
  componentDidMount() {
    if (typeof window !== 'undefined') {
      window.isFullScreenPage = true;
      flexible.flexible(window, window.lib || (window.lib = {}));
    }
  }

  render() {
    return <div />;
  }
}
